import Vue from 'vue'
import VueRouter from 'vue-router'
import pkg from '../../package.json'
import Layout from '@/layout'
import { isLogin, showLogin } from '@/shared/user'
import { queryOrderByOuterOrderNo, queryLoginMobileByOuterOrderNo } from '@/api/order'
import store from '@/store'
import { resolveCustomerCodeByHost, resolveDevCustomerCode } from '@/util/domainMap'
import { decideCaGuard } from '@/views/ca/util/caGuard'
Vue.use(VueRouter)

export const routes = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Home',
        meta: {
          name: '首页',
        },
        component: () => import('../views/home/main.vue'),
      },
      {
        path: '/home',
        redirect: '/',
      },
      {
        path: '/zcm',
        name: 'ZCM',
        meta: {
          name: '商票贴现（线上贷款）',
        },
        component: () => import('../views/zcm/zcm.vue'),
      },
      {
        path: '/preview',
        name: 'PreviewPDF',
        meta: {
          name: '预览PDF',
        },
        props: (route) => ({ id: route.query.url }),
        component: () => import('@/views/previewPdf/preview'),
      },
      {
        path: '/bank_pdf_view',
        name: 'BankPdfView',
        meta: {
          name: '样张预览',
        },
        component: () => import('../views/electronic/bank/components/preview.vue'),
      },
      {
        path: '/electronic_bank_pdf_view',
        name: 'ElectronicBankPdfView',
        meta: {
          name: '电子银行保函样张浏览',
        },
        component: () => import('../views/electronic/bank/components/electronicLetterCmmmit.vue'),
      },
      {
        path: '/electronic_bank_pdf_view_ok',
        name: 'ElectronicBankPdfViewOk',
        meta: {
          name: '电子银行保函申请书浏览签章',
        },
        component: () => import('../views/electronic/bank/components/electronicLetterCmmmitOk.vue'),
      },
      // 安徽移动
      {
        path: '/anhui',
        redirect: '/anhui/bank',
        name: 'Anhui',
        component: () => import('../views/electronic/index.vue'),
        children: [
          {
            path: 'bank',
            meta: {
              name: '电子-银行投标保函',
            },
            component: () => import('../views/electronic/bank/bank.vue'),
            redirect: '/anhui/bank/step1',
            children: [
              {
                path: 'step1',
                meta: {
                  name: '企业信息',
                },
                component: () => import('../views/electronic/bank/step1.vue'),
              },
              {
                path: 'step2',
                meta: {
                  name: '项目信息',
                },
                component: () => import('../views/electronic/bank/step2.vue'),
              },
            ],
          },
        ],
      },
      // 贵州银行
      {
        path: '/guizhouBank',
        redirect: '/guizhouBank/bank',
        name: 'guizhouBank',
        component: () => import('../views/electronic/index.vue'),
        children: [
          {
            path: 'bank',
            meta: {
              name: '电子-银行投标保函',
            },
            component: () => import('../views/electronic/bank/bank.vue'),
            redirect: '/guizhouBank/bank/step1',
            children: [
              {
                path: 'step1',
                meta: {
                  name: '企业信息',
                },
                component: () => import('../views/electronic/bank/step1.vue'),
              },
              {
                path: 'step2',
                meta: {
                  name: '项目信息',
                },
                component: () => import('../views/electronic/bank/step2.vue'),
              },
            ],
          },
        ],
      },
      {
        path: '/applyBankMain',
        redirect: '/applyBankMain/bank',
        name: 'applyBankMain',
        component: () => import('../views/electronic/index.vue'),
        children: [
          {
            path: 'bank',
            meta: {
              name: '申请银行保函',
            },
            component: () => import('../views/electronic/bank/bank.vue'),
            redirect: '/applyBankMain/bank/step1',
            children: [
              {
                path: 'step1',
                meta: {
                  name: '申请银行保函-企业信息',
                },
                component: () => import('../views/electronic/bank/step1.vue'),
              },
              {
                path: 'step2',
                meta: {
                  name: '申请银行保函-项目信息',
                },
                component: () => import('../views/electronic/bank/step2.vue'),
              },
            ],
          },
          {
            path: 'guaranteeBankView',
            meta: {
              name: '申请电子担保保函',
            },
          },
          {
            path: 'applyInsurance',
            meta: {
              name: '申请保险保函',
            },
          },
          {
            path: 'applicationPerformance',
            meta: {
              name: '申请履约保函',
            },
          },
        ],
      },
      {
        path: '/applyInsurance',
        name: 'applyInsurance',
        meta: {
          name: '申请保险保函',
        },
        component: () =>
          import('../views/applyInsuranceView/applyInsuranceMain.vue'),
      },
      {
        path: '/guaranteeBankView',
        name: 'guaranteeBankView',
        meta: {
          name: '申请电子担保保函',
        },
        component: () =>
          import('../views/guaranteeBankView/guaranteeBankView.vue'),
      },
      {
        path: '/letterCmmmit',
        name: 'letterCmmmit',
        meta: {
          name: '保函样张确认',
        },
        props: (route) => ({ orderID: route.query.order }),
        component: () => import('../views/letterCmmmit/letterCmmmit.vue'),
      },
      {
        path: '/insuranceLetterCmmmit',
        name: 'insuranceLetterCmmmit',
        meta: {
          name: '投保单确认',
        },
        props: (route) => ({ orderID: route.query.order }),
        component: () => import('../views/letterCmmmit/insuranceLetterCmmmit.vue'),
      },
      {
        path: '/flineSignLetterCmmmit',
        name: 'flineSignLetterCmmmit',
        meta: {
          name: '承诺书上传',
        },
        props: (route) => ({ orderID: route.query.order }),
        component: () => import('../views/letterCmmmit/flineSignLetterCmmmit.vue'),
      },
      {
        path: '/letterCmmmitOk',
        name: 'letterCmmmitOk',
        meta: {
          name: '承诺书签订',
        },
        component: () => import('../views/letterCmmmit/letterCmmmitOk.vue'),
      },
      {
        path: '/wire-transfer',
        name: 'wireTransfer',
        meta: {
          name: '电汇信息',
        },
        component: () => import('../views/wireTransfer/wireTransfer.vue'),
      },
      {
        path: '/help',
        name: 'Help',
        meta: {
          name: '帮助中心',
        },
        component: () => import('../views/help/index.vue'),
      },
      {
        path: '/personalInfo',
        name: 'personalInfo',
        meta: {
          name: '我的资料',
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/personInfo/personalInfo.vue'
          ),
      },
      {
        path: '/aboutUs',
        name: 'aboutUs',
        meta: {
          name: '关于我们',
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/aboutUs/aboutUs.vue'
          ),
      },
      {
        path: '/applicationPerformance',
        name: 'applicationPerformance',
        meta: {
          name: '申请履约保函',
        },
        component: () =>
          import(
            /* webpackChunkName: "about" */ '../views/applicationPerformance/applicationperformance.vue'
          ),
      },
      {
        path: '/verify',
        name: 'Verify',
        meta: {
          name: '保函查验',
        },
        component: () => import('../views/verify/index.vue'),
      },
      {
        path: '/pay-result',
        name: 'payResult',
        meta: {
          name: '订单状态',
        },
        component: () =>
          import(
            /* webpackChunkName: "pay" */ '../views/paySuccess/paySuccess.vue'
          ),
      },
      {
        path: '/orderListIndex',
        name: 'orderListIndex',
        meta: {
          name: '我的订单',
        },
        component: () => import('../views/orderLists/index.vue'),
      },
      {
        path: '/orderDetail',
        name: 'orderDetail',
        meta: {
          name: '订单详情',
        },
        props: (route) => ({ orderID: route.query.order }),
        component: () => import('../views/orderLists/orderDetail.vue'),
      },
      {
        path: '/invoiceIndex',
        name: 'invoiceIndex',
        meta: {
          name: '发票信息',
        },
        component: () => import('../views/invoices/index.vue'),
      },
      {
        path: '/bidWoodpecker',
        name: 'bidWoodpecker',
        meta: {
          name: '标书啄木鸟',
        },
        component: () => import('../views/bidWoodpecker/Home'),
      },

    ],
  },
  {
    path: '/intermediary',
    name: 'intermediary',
    meta: {
      name: '',
    },
    component: () => import('../views/intermediary/index.vue'),
  },
  // —— CA 在线申请（用户端）：独立路由组 + 专用布局，不挂主站 Layout ——
  {
    path: '/ca/error',
    name: 'ca-error',
    meta: { name: '无法识别客户门户' },
    component: () => import('../views/ca/error.vue'),
  },
  {
    path: '/ca',
    component: () => import('../views/ca/layout/CaLayout.vue'),
    children: [
      {
        path: 'apply',
        name: 'ca-apply',
        meta: { name: 'CA在线申请' },
        component: () => import('../views/ca/apply/index.vue'),
      },
      {
        // 空路径容器：给个人中心各页统一包一层含左侧导航的布局（URL 不变，只是多嵌一层 component）
        path: '',
        component: () => import('../views/ca/layout/CaCenterLayout.vue'),
        children: [
          {
            path: 'orders',
            name: 'ca-orders',
            meta: { name: '我的订单' },
            component: () => import('../views/ca/order/list.vue'),
          },
          {
            path: 'orders/detail',
            name: 'ca-order-detail',
            meta: { name: '订单详情' },
            component: () => import('../views/ca/order/detail.vue'),
          },
          {
            path: 'orders/edit',
            name: 'ca-order-edit',
            meta: { name: '订单编辑' },
            component: () => import('../views/ca/order/edit.vue'),
          },
          {
            path: 'orders/renew',
            name: 'ca-order-renew',
            meta: { name: 'CA在线续签' },
            component: () => import('../views/ca/order/renew.vue'),
          },
          {
            path: 'wire-transfer',
            name: 'ca-wire-transfer',
            meta: { name: '支付订单' },
            component: () => import('../views/ca/order/wireTransfer.vue'),
          },
          {
            path: 'contact',
            name: 'ca-contact',
            meta: { name: '联系我们' },
            component: () => import('../views/ca/order/contact.vue'),
          },
        ],
      },
    ],
  },
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
})

const interceptView = ['/orderListIndex', '/orderDetail', '/invoiceIndex']
const outsidepath = ['/applyBankMain/bank/step1', '/applyBankMain/bank/step2', '/guaranteeBankView', '/applicationPerformance', '/orderDetail']

const isChongqingWaterDomain = () => {
  try {
    const domain = window.location.hostname.toLowerCase();
    const isCqsw = domain.includes('cqsw')||domain.includes('192.168.1.17')||domain.includes('localhost')
    store.commit('letter/setIsCqsw', isCqsw)
    return isCqsw
  } catch (err) {
    console.error('域名判断失败:', err)
    return false
  }
}

const isHljWaterDomain = () => {
  try {
    const domain = window.location.hostname.toLowerCase()
    const isHlj = domain.includes('hlj')
    store.commit('letter/setIsHlj', isHlj)
    return isHlj
  } catch (err) {
    console.error('域名判断失败:', err)
    return false
  }
}

const isBsgzwDomain = () => {
  try {
    const domain = window.location.hostname.toLowerCase();
    const isBsgzw = domain.includes('bsgzw')
    store.commit('letter/setIsBsgzw', isBsgzw)
    return isBsgzw
  } catch (err) {
    console.error('域名判断失败:', err)
    return false
  }
}

router.beforeEach((to, from, next) => {
  // if (to.path === '/') {
  // localStorage.setItem('ZCJF-STORAGE','')
  // }
  const shouldSetCqswTitle = isChongqingWaterDomain()
  const shouldSetHljTitle = isHljWaterDomain()
  const shouldSetBsgzwTitle = isBsgzwDomain()

  // —— CA 在线申请：客户域名整站接管 + customerCode 三级解析（决策逻辑在 util/caGuard，纯函数可单测）——
  const caDecision = decideCaGuard(to, {
    hostCode: resolveCustomerCodeByHost(window.location.hostname),
    storeCode: store.state.ca.customerCode,
    devCode: resolveDevCustomerCode(window.location.hostname),
    loggedIn: isLogin(),
  })
  if (caDecision.commitCode) store.commit('ca/setCustomerCode', caDecision.commitCode)
  if (caDecision.showLogin) showLogin()
  if (caDecision.action === 'redirect') {
    // ⚠️ 必须 return —— 本守卫末尾还有一个无条件 next()，不 return 会重复调用 next
    return next({ name: caDecision.name, replace: true })
  }
  // CA 页面统一改浏览器标题：index.html 默认标题是主站「保函在线办理」，
  // 进入 /ca 前缀路由（含整站接管的客户域名）时覆盖为「CA在线申请」
  console.log('路由守卫', to.path, to.path.indexOf('/ca/'))
  if (to.path === '/ca' || to.path.indexOf('/ca/') === 0) {
    document.title = 'CA在线申请'
  }

  if (interceptView.includes(to.path)) {
    if (!isLogin()) {
      showLogin()
    }
  }
  if (to.fullPath === '/applyBankMain/bank/step1') {
    localStorage.removeItem('ZCJF-STORAGE')
  }
  if (shouldSetCqswTitle) {
    to.meta.name && (document.title = `${to.meta.name} -- 重庆水务环境集团招标采购信息系统平台`)
  }
  if (shouldSetHljTitle) {
    to.meta.name && (document.title = `${to.meta.name} -- 黑龙江`)
  }
  if (shouldSetBsgzwTitle) {
    to.meta.name && (document.title = `${to.meta.name} -- 保山`)
  }
  if (outsidepath.includes(to.path) && to.query.outerOrderNo && !(to.query.step2Id || to.query.step1Id)) {
    queryLoginMobileByOuterOrderNo(to.query.outerOrderNo).then((v) => {
      if (v.data) {
        // 免认证登录
        if (to.query.sign) {
          const mobile = store.state.user.userInfo?.mobile || ''
          if (v.data.loginMobile === mobile) {
            return
          }
          store
            .dispatch('user/phoneLogin4', {
              phone: v.data.loginMobile,
              outerOrderNo: to.query.outerOrderNo,
              apiId: to.query.apiId,
              requestTime: to.query.requestTime,
              sign: to.query.sign,
            })
            .then(() => {
            // 进入详情页
              if (to.path.includes('orderDetail')) {
                window.location.replace('#/orderDetail?order=' + to.query.order)
              }
            })
            .catch(() => {
            })
        }
      }
    })
  }
  next()
//   if (to.meta.name) {
//     const title = to.meta.name === '首页' ? pkg.title : `${to.meta.name} -- ${pkg.title}`;
//     document.title = title;
// }
})

export default router
